import { SoapUtils } from "../../../../utils/SoapUtils";
import { BaseRequest, IBaseRequest } from "../../BaseRequest";
import {
  toDocumentXml,
  toTransactionXml,
  Transaction,
} from "../../dataObjects/Invoice";
import { Documents } from "../../dataObjects/MessageTemplate";

export interface ICreateEntryRequest extends IBaseRequest {
  id?: string;
  acl?: string;
  templateAcc?: string;
  treeHandle?: string;
  journal?: string;
  invoice?: string;
  plan?: string;
  subject?: string;
  project?: string;
  activity?: string;
  TRANSACTION?: Transaction[];
  DOCUMENTS?: Documents;
  RELATED_ENTRIES?: RelatedEntries;
}

export interface RelatedEntries {
  ENTRY: Entry[];
}

export interface Entry {
  id?: string;
  invoice?: string;
  invoiceNumber?: string;
}

export function toEntryXml(entry: Entry): string {
  let xml = `<ENTRY>`;
  xml += SoapUtils.makeNode(entry.id, "id");
  xml += SoapUtils.makeNode(entry.invoice, "invoice");
  xml += SoapUtils.makeNode(entry.invoiceNumber, "invoiceNumber");
  xml += `</ENTRY>`;
  return xml;
}

export class CreateEntryRequest
  extends BaseRequest
  implements ICreateEntryRequest
{
  public id?: string;
  public acl?: string;
  public templateAcc?: string;
  public treeHandle?: string;
  public journal?: string;
  public invoice?: string;
  public plan?: string;
  public subject?: string;
  public project?: string;
  public activity?: string;
  public TRANSACTION?: Transaction[];
  public DOCUMENTS?: Documents;
  public RELATED_ENTRIES?: RelatedEntries;

  constructor(
    server: string,
    session: string,
    options?: Partial<ICreateEntryRequest>,
  ) {
    super(server, session);
    if (options) {
      Object.assign(this, options);
    }
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.id, "id");
    parameters += this.makeNode(this.acl, "acl");
    parameters += this.makeNode(this.templateAcc, "templateAcc");
    parameters += this.makeNode(this.treeHandle, "treeHandle");
    parameters += this.makeNode(this.journal, "journal");
    parameters += this.makeNode(this.invoice, "invoice");
    parameters += this.makeNode(this.plan, "plan");
    parameters += this.makeNode(this.subject, "subject");
    parameters += this.makeNode(this.project, "project");
    parameters += this.makeNode(this.activity, "activity");
    parameters += this.makeNodeArray(this.TRANSACTION, (transaction) =>
      toTransactionXml(transaction),
    );
    if (this.DOCUMENTS) {
      parameters += this.makeNodeArray(
        this.DOCUMENTS.DOCUMENT,
        (document) => toDocumentXml(document),
        "DOCUMENT",
      );
    }
    if (this.RELATED_ENTRIES) {
      parameters += this.makeNodeArray(
        this.RELATED_ENTRIES.ENTRY,
        (entry) => toEntryXml(entry),
        "ENTRY",
      );
    }
    return super.wrapperXml("CreateEntry", parameters);
  }
}
